import * as React from 'react';
import { IBanner } from '../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';

interface IProps {
    place: number,
}

interface IState {
    banner: IBanner,
    html: string,
    script: string,
    show: boolean,
    time: number,
    start: number
}

export default class PopupBanner extends React.Component<IProps, IState> {
    private timer: any;
    private _isUnmounted: boolean = false;

    constructor(props: IProps) {
        super(props);

        this.state = {
            banner: null,
            html: null,
            script: null,
            show: false,
            time: 0,
            start: 0
        }

        this.startTimer = this.startTimer.bind(this)
        this.stopTimer = this.stopTimer.bind(this)
    }

    startTimer() {
        this.setState({
            time: this.state.time,
            start: Date.now() - this.state.time
        })

        this.timer = setInterval(() => {
            this.setState({
                time: Date.now() - this.state.start
            }, () => {
                let second = this.state.banner.second ? this.state.banner.second : 10;
                second = second * 1000;

                if (this.state.time >= second) {
                    this.stopTimer();
                    this.closeModal();
                }
            })
        }, 1000);
    }

    stopTimer() {
        clearInterval(this.timer);
    }

    async loadBanner() {
        try {
            let response: AxiosResponse = await Axios.get(`${config.host}/banner/place?number=${this.props.place}`);

            let { data } = response;

            if (data){

                if (data.is_inner == 0) {
                    let htmlResponse = data.link;
                    htmlResponse = htmlResponse.replace('<script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>', '');
    
                    let extractedScript = /<script[\s\S]*?>[\s\S]*<\/script>/g.exec(htmlResponse)[0];
    
                    if (!this._isUnmounted)
                        this.setState({
                            html: htmlResponse,
                            script: extractedScript,
                            banner: {
                                ...response.data,
                                link: htmlResponse
                            },
                            show: true,
                        }, this.startTimer);
    
                } else {
                    if (!this._isUnmounted)
                        this.setState({
                            banner: response.data,
                            show: true,
                        }, this.startTimer);
                }

                localStorage.setItem("lastDate", (new Date()).toUTCString());
            } else {
                if (!this._isUnmounted)
                    this.setState({
                        show: false,
                    });
            }
        } catch (err) {

        }
    }

    async componentDidMount() {
        let lastDateString = localStorage.getItem("lastDate");

        if (lastDateString) {
            let lastDate = new Date(lastDateString);
            let now = new Date();

            let diffMs = (now.getTime() - lastDate.getTime());
            let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

            if (diffMins >= 4 * 60) {
                await this.loadBanner();
            }
        } else {
            await this.loadBanner();
        }
    }

    componentDidUpdate() {
        // this runs the contents in script tag on a window/global scope
        let scriptToRun = this.state.script;

        if (scriptToRun) {
            scriptToRun = scriptToRun.replace(/<script[\s\S]*?>/g, "");
            scriptToRun = scriptToRun.replace(/<\/script>/g, "");
            
            //remove <script> and </script> tags since eval expects only code without html tags
            try {
                (window as any).eval(scriptToRun)
            } catch (err) {
            }
        }
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    closeModal() {
        this.setState({
            show: false
        })
    }

    render() {
        return (

            <div>
                <div className={"modal popup-modal fade in bs-example-modal-lg " + (this.state.show ? "in" : '')}
                    style={{
                        display: this.state.show ? "block" : ''
                    }} id="authModal" tabIndex={-1} role="dialog" aria-labelledby="authModalLabel">
                    <button type="button" className="close popup-close" data-dismiss="modal" aria-label="Close" onClick={(event: React.MouseEvent) => {
                        this.closeModal();
                    }}><span aria-hidden="true">&times;</span></button>
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-body text-center p-0">
                                {this.state.banner && this.state.banner.is_inner == 1 && (
                                    <a href={this.state.banner.path} target="_blank">
                                        <img className="img-responsive" style={{ width: "100%" }} src={this.state.banner.fullPath} alt="" />
                                    </a>
                                )}
                                {this.state.banner && this.state.banner.is_inner == 0 && (
                                    <div dangerouslySetInnerHTML={{
                                        __html: this.state.banner.link
                                    }}></div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.show && <div className="modal-backdrop fade in"></div>}
            </div>

        );
    }
}
